// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gh-0";
export var actionModalContentContainer = "_gh-1";
export var createTagButton = "_gh-2";
export var footerContainer = "_gh-7";
export var fullWidthDivider = "_gh-3";
export var hasCreateTagButton = "_gh-4";
export var noCreateTagButton = "_gh-5";
export var tagsContainer = "_gh-6";
export var tagsModalContentContainer = "_gh-8";